export enum LegalPacketSection {
  InvestigationDetails = 'InvestigationDetails',
  PartiesInvolved = 'PartiesInvolved',
  Complainant = 'Complainant',
  Respondent = 'Respondent',
  Witnesses = 'Witnesses',
  AssignedInvestigator = 'AssignedInvestigator',
  AllegedViolations = 'AllegedViolations',
  EvidenceLocker = 'EvidenceLocker',
  InterviewRoom = 'InterviewRoom',
  Details = 'Details',
  Questions = 'Questions',
  InterviewNotes = 'InterviewNotes',
  Credibility = 'Credibility',
  InvestigationResult = 'InvestigationResult',
  ResultDetermination = 'ResultDetermination',
  InvestigationFindingsNotes = 'InvestigationFindingsNotes',
  InvestigationTimeline = 'InvestigationTimeline',
}
